import React from "react";
import Styled from "@emotion/styled";

// import sketch from "./driverSketch.png";
import sketch from "../imgs/environmentWith.png";

import sketch1 from "../imgs/network.png";

const Background = (props) => {
  const Container = Styled.div`
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        @media (max-width: 1100px) {
          min-width: 0;
          flex-direction: column;
        }
    `;
  const Subheader = Styled.div`
        font-size: 3em;
        color: #35a1f9;

        

    `;
  const Side = Styled.div`
        display: flex;
        flex-direction: column;

        @media (max-width: 1100px) {
          width: 100%;
          flex-direction: row;
          margin-top: 5%;
        }
    `;
  const Title = Styled.div`
    color: #000000;
    font-size: 5em;
    font-weight: 600;

    @media (max-width: 1100px) {
      font-size: 1.5em;
    }
  `;

  const Sketches = Styled.img`
    width: 30vw;
    margin-top: -5v;
    transform: rotate(-0deg);

    @media (max-width: 1100px) {
      width: 30vw;
      transform: rotate(0deg);
      marin-top: 0;
    }
    `;
  const Sketches1 = Styled.img`
    width:35vw;
    margin-top: -7vh;
    margin-left: -2vw;
    transform: rotate(0deg);

    @media (max-width: 1100px) {
      width: 48vw;
      margin-left: 0;
      margin-top: 2%;
    }
  `;

  const Text = Styled.div`
    font-size: 1.5vw;
    width: 45vw;
    min-width: 500px;
    line-height: 1.8em;

    @media (max-width: 1100px) {
      width: 100%;
      min-width: 0;
      font-size: 1em;
    }
  `;
  return (
    <div className={props.isVisible ? "animated fadeIn" : "animated fadeOut"}>
      <Title>Background</Title>
      <Subheader>The process</Subheader>
      <Container>
        <Side>
          <Sketches src={sketch} style={{}}></Sketches>
          <Sketches1 src={sketch1} style={{}}></Sketches1>
        </Side>
        <Side>
          <Text>
            This project is a demonstration of artificial intelligence and my
            personal take on driving AI. This game/environment/demo consists of
            a player car (the only blue car) in addition to CPU cars. The goal
            of this entire game is to make a left turn through the intersection
            losing as little points as possible. Everything is based on points,
            and doing anything that goes against proper driving will take off
            points from the initial 10000 points. Starting 2020, I aspired to
            improve my Java proficiency in addition to gaining more experience
            with Artificial Intelligence; more specifically neural networks.
            From those requirements I idealized this creation; it is adequately
            complex to do over a few months, while being straight forward enough
            to complete while working full time as a software developer intern.
          </Text>
        </Side>
      </Container>
    </div>
  );
};
export default Background;
